export function getAccountingToken(state) {
    return state.accountingToken
}

export function getAccountingUrl(state) {
    return state.accountingUrl
}
export function getCompanies(state) {
    return state.companies
}

export function getSignature(state) {
    return state.signature
}
export function isAdmin(state) {
    return parseInt(state.role_id) === 2
}

export function isSuperAdmin(state) {
    return parseInt(state.role_id) === 1
}

export function isEmployee(state) {
    return parseInt(state.role_id) === 3
}

export function userId(state) {
    return state.user_id;
}


